import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { LinkSimple } from "@phosphor-icons/react";

const OrphanRow = ({ o, staffOptions, onLinked }) => {
  const [sid, setSid] = useState("");
  const [busy, setBusy] = useState(false);
  const [askDel, setAskDel] = useState(false);
  const canDelete = !o.activated && !["super_admin", "admin"].includes(o.role);
  const del = async () => {
    setBusy(true);
    try { const r = await api.delete(`/admin/orphan-accounts/${o.user_id}`); toast.success(r.data.message); onLinked(); }
    catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); setAskDel(false); }
  };
  const link = async () => {
    if (!sid) return toast.error("Pilih petugas tujuan");
    setBusy(true);
    try {
      const r = await api.post("/admin/orphan-accounts/link", { user_id: o.user_id, staff_id: sid });
      toast.success(r.data.message); onLinked();
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid={`orphan-row-${o.user_id}`} className="flex flex-col gap-2 rounded-lg border border-amber-100 bg-white p-2.5 text-xs sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <p className="font-semibold text-slate-800">{o.petugas_nama || "—"}</p>
        <p className="break-all text-slate-600">{o.email}</p>
        <p className="text-[10px] text-slate-400">{o.role} · {o.activated ? "sudah diaktifkan" : "belum aktivasi"}{o.disabled ? " · login nonaktif" : ""} · staff lama: <span className="font-mono">{o.old_staff_id || "(kosong)"}</span></p>
      </div>
      <div className="flex flex-col gap-1.5 sm:flex-row sm:shrink-0">
        <select data-testid={`orphan-target-${o.user_id}`} value={sid} onChange={(e) => setSid(e.target.value)} className="w-full rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs sm:w-56">
          <option value="">Pilih petugas tanpa akun…</option>
          {staffOptions.map((s) => <option key={s.id} value={s.id}>{s.nama}{s.aktif ? "" : " (nonaktif)"}</option>)}
        </select>
        <button data-testid={`orphan-link-${o.user_id}`} disabled={busy} onClick={link} className="flex items-center justify-center gap-1 rounded-lg bg-amber-500 px-2.5 py-1.5 text-xs font-bold text-white disabled:opacity-60"><LinkSimple size={12} weight="bold" /> Tautkan ke petugas</button>
        {canDelete && !askDel && <button data-testid={`orphan-delete-${o.user_id}`} disabled={busy} onClick={() => setAskDel(true)} className="rounded-lg bg-rose-50 px-2.5 py-1.5 text-xs font-bold text-rose-600">Hapus akun</button>}
        {askDel && (
          <div data-testid={`orphan-delete-confirm-${o.user_id}`} className="flex items-center gap-1.5 rounded-lg bg-rose-50 px-2 py-1 text-[11px] text-rose-700">
            Hapus {o.email}?
            <button data-testid={`orphan-delete-yes-${o.user_id}`} disabled={busy} onClick={del} className="rounded bg-rose-600 px-2 py-1 font-bold text-white disabled:opacity-60">Ya, hapus</button>
            <button data-testid={`orphan-delete-no-${o.user_id}`} onClick={() => setAskDel(false)} className="rounded bg-white px-2 py-1 font-semibold text-slate-600">Batal</button>
          </div>
        )}
      </div>
    </div>
  );
};

export const OrphanAccountsPanel = ({ orphans, staff, onLinked }) => {
  const staffOptions = staff.filter((s) => !s.has_account);
  return (
    <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50/60 p-3" data-testid="orphan-accounts-panel">
      <p className="text-xs font-bold text-amber-800">Akun tanpa petugas (yatim) · {orphans.length}</p>
      <p className="mb-2 text-[11px] text-amber-700">Akun login yang petugasnya sudah dihapus. Menautkan tidak mereset password dan tidak mengirim email/WA.</p>
      {orphans.length === 0 ? <p data-testid="orphan-empty" className="text-xs text-slate-500">Tidak ada akun yatim.</p> : (
        <div className="space-y-2">{orphans.map((o) => <OrphanRow key={o.user_id} o={o} staffOptions={staffOptions} onLinked={onLinked} />)}</div>
      )}
    </div>
  );
};
